export type RuntimeEnvironment = 'local' | 'dev' | 'uat' | 'prd' | 'unknown';

export type RuntimeEnvironmentDisplay = {
  environment: RuntimeEnvironment;
  label: 'LOCAL' | 'DEV' | 'UAT' | null;
  visible: boolean;
};

export function resolveRuntimeEnvironment({
  isDev,
  appEnvironment,
}: {
  isDev: boolean;
  appEnvironment: string | undefined;
}): RuntimeEnvironmentDisplay {
  if (isDev) {
    return {
      environment: 'local',
      label: 'LOCAL',
      visible: true,
    };
  }

  const environment = appEnvironment?.trim().toLowerCase();

  if (environment === 'dev') {
    return {
      environment: 'dev',
      label: 'DEV',
      visible: true,
    };
  }

  if (environment === 'uat') {
    return {
      environment: 'uat',
      label: 'UAT',
      visible: true,
    };
  }

  if (environment === 'prd') {
    return {
      environment: 'prd',
      label: null,
      visible: false,
    };
  }

  return {
    environment: 'unknown',
    label: null,
    visible: false,
  };
}
